import axios from "axios";
import { keycloak } from "../../../lib/keycloak/index.ts";
import { FinancialAdvisorAvailabilityUpdateDTO } from "../dto.ts";
import { AppointmentFiltersDTO, AppointmentResponseDTO, AppointmentsCreateDTO, AppointmentsDTO, AppointmentsUpdateRequestDTO, UpdateStatusRequest } from "./dto.ts";
import { AppointmentsService } from "./service.ts";

export class AppointmentsServiceImpl implements AppointmentsService {

    public updateAvailabilitesFinancialAdvisor(id: string, request: FinancialAdvisorAvailabilityUpdateDTO): Promise<void> {
        let url: string = "/api/financialAdvisors/availability/update/" + id
        return axios({
            url: url,
            method: "PUT",
            data: request,
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public appointmentsCreate(request: AppointmentsCreateDTO): Promise<void> {
        let url: string = "/api/event-scheduler"
        return axios({
            url: url,
            method: "POST",
            data: request,
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public findAllAppointments(filters: AppointmentFiltersDTO): Promise<AppointmentResponseDTO> {
        let url: string = "/api/event-scheduler"
        let params = {
            companyId: filters.companyId,
            financialAdvisorId: filters.financialAdvisorId,
            fromDate: filters.fromDate,
            itemsPerPage: filters.itemsPerPage,
            toDate: filters.toDate,
            order: filters.order,
            sort: filters.sort
        }
        return axios({
            url: url,
            method: "GET",
            params: params,
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public appointmentsDelete(id: string): Promise<void> {
        let url: string = "/api/event-scheduler/" + id
        return axios({
            url: url,
            method: "DELETE",
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public findByIdAppointment(id: string): Promise<AppointmentsDTO> {
        let url: string = "/api/event-scheduler/" + id
        return axios({
            url: url,
            method: "GET",
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public rescheduleAppointment(id: string, request: AppointmentsUpdateRequestDTO): Promise<void> {
        let url: string = "/api/event-scheduler/reschedule/" + id
        return axios({
            url: url,
            method: "PUT",
            data: request,
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }
    public updateStatusAppointment(id: string, request: UpdateStatusRequest): Promise<void> {
        let url: string = "/api/event-scheduler/update-status/" + id
        return axios({
            url: url,
            method: "PUT",
            data: request,
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }
}
